/**
 * Helper functions for checking if variables are undefined
 * For full documentation: {@link https://www.devnet.io/libs/react-registry/}
 *
 * @author Joe Esposito <joe@devnet.io>
 */
import Class from "./Class";

export default class TypeUtil {

	public static iDef<T = any>(o: T, callback?: (it?: T) => any) {
		if(typeof o !== "undefined") {
			if(typeof callback !== "undefined") {
				callback(o);
			}
			return true;
		}
		return false;
	}

	public static nDef<T = any>(o: T, callback?: (it?: undefined) => any) {
		if(typeof o === "undefined") {
			if(typeof callback !== "undefined") {
				callback(o);
			}
			return true;
		}
		return false;
	}

	// default value null instead of undefined for returning from react render
	public static iLet<T>(o: T, callback: (T) => any, defaultValue: any = null): any {
		if(o) {
			return callback(o);
		}
		return defaultValue;
	}

	// conditional assign
	public static cAsgn(to: any, from: any) {
		if(iDef(from)) {
			to = from;
		}
	}

	// is defined and has length
	public static iDefL(o: any, callback?: (it?: any) => any) {
		if (typeof o !== 'undefined' && o.length && o.length > 0) {
			if (typeof callback === 'function') {
				callback(o);
			}
			return true;
		}
		return false;
	}

	public static default(desiredValue, defaultValue) {
		if(iDef(desiredValue)) {
			return desiredValue;
		}

		return defaultValue;
	}

	public static become<T>(source: object, newClass: Class<T>): T {
		const obj = {...source} as any; // copy incase Object.preventExtensions() has been used
		obj.__proto__ = ((new newClass()) as any).__proto__;
		return obj;
	}
}

// export
export const iDef = TypeUtil.iDef;
export const nDef = TypeUtil.nDef;
export const cAsgn = TypeUtil.cAsgn;
export const iDefL = TypeUtil.iDefL;
export const defaultValue = TypeUtil.default;
export const iLet = TypeUtil.iLet;



// WEBPACK FOOTER //
// ./src/core/util/TypeUtils.ts